import { atom } from 'jotai';

export const activityOutcomesAtom = atom([]);
export const activityTypesAtom = atom([]);
export const themeAtom = atom(localStorage.getItem('theme') || 'light');
export const subsectionsAtom = atom([]);

export const allOutcomesAtom = atom([]);

export const outcomesAtom = atom([]);

export const lpgLinksAtom = atom([]);

export const selectedCustomerIdAtom = atom('');

export const additionalCustomerDataAtom = atom({});

export const endedCallDataAtom = atom(null);

export const registeredCallDataAtom = atom(null);

export const userDataAtom = atom(null);

export const userBranchesAtom = atom(null);

export const selectedBranchAtom = atom(null);

export const filterAppliedAtom = atom(false);

export const searchValuesAtom = atom(null);

export const currentDateAtom = atom(new Date());

export const loadingCounterAtom = atom(0);

export const notificationDrawerOpenAtom = atom(false);

export const openSnackbarAdviseAtom = atom(null);

export const unreadMessagesCounterAtom = atom(0);

export const occupationsAtom = atom(null);

export const productsAtom = atom(null);

export const practiceProductAtom = atom(null);

export const alertDialogAtom = atom(null);

export const selectedLeadIdAtom = atom('');

export const reloadLeadsAtom = atom(false);

export const reloadAtom = atom(false);
export const maxDistanceAtom = atom(150);
